<template functional>
	<div
		class="card-list-item"
		@click="props.itemClick(props.data.product_uuid)"
	>
		<div class="package-title">{{ props.data.title }}</div>
		<div class="package-desc">{{ props.data.subtitle }}</div>
		<div class="package-price">
			<div class="price-line">
				<!-- <span class="price-unit">￥</span> -->
				<!-- <span>{{parseFloat(props.data.package_price)}}元/{{props.data.package_cnt}}</span> -->
				<span>{{ parseFloat(props.data.package_price) }}元</span>/
				<span v-if="props.data.package_way != 2"
					>{{ props.data.package_cnt }}次</span
				>
				<span v-if="props.data.package_way == 2"
					>{{ props.data.package_month }}个月</span
				>
				<!-- <span class="package-count">（{{props.data.package_cnt}}次）</span> -->
			</div>
			<button class="buy-now">立即购买</button>
		</div>
		<!-- <div class="see-detail">查看详情</div> -->
	</div>
</template>
<script>
export default {
	name: "card",
	props: {
		data: {
			type: Object,
			required: true
		},
		itemClick: {
			type: Function,
			required: true
		}
	}
};
</script>
<style scoped lang="less">
.card-list-item {
	position: relative;
	margin-top: 20px;
	padding: 26px 20px;
	display: inline-block;
	height: 200px;
	width: 280px;
	font-size: 0;
	cursor: pointer;
	overflow: hidden;
	background-color: #fff;

	&:not(:nth-child(4n + 1)) {
		margin-left: 20px;
	}
	.package-title {
		display: -webkit-box;
		font-size: 14px;
		color: #222;
		line-height: 1.5;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		overflow: hidden;
	}
	.package-desc {
		display: -webkit-box;
		margin-top: 6px;
		font-size: 12px;
		color: #999;
		line-height: 1.5;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 3;
		overflow: hidden;
	}
	.package-price {
		position: absolute;
		bottom: 16px;
		left: 20px;
		right: 20px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		font-size: 20px;
		color: #f70;
	}
	.price-line {
		display: flex;
		align-items: baseline;
	}
	.price-unit {
		font-size: 14px;
	}
	.package-count {
		display: inline-block;
		height: 100%;
		font-size: 12px;
		color: #999;
	}
	.buy-now {
		display: flex;
		align-items: center;
		justify-content: center;
		flex: 0 0 80px;
		width: 80px;
		height: 30px;
		font-size: 14px;
		color: #f70;
		border: 1px solid #f70;
		border-radius: 3px;
		cursor: pointer;
	}
	// .see-detail {
	// 	position: absolute;
	// 	bottom: 0;
	// 	left: 0;
	// 	right: 0;
	// 	display: flex;
	// 	height: 48px;
	// 	justify-content: center;
	// 	align-items: center;
	// 	font-size: 14px;
	// 	color: #fff;
	// 	background-color: #f70;
	// 	transform: translateY(48px);
	// 	transition: all ease 0.25s;
	// }
	&:hover {
		box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.12);

		// .see-detail {
		// 	transform: translateY(0);

		// }
	}
}
</style>



// WEBPACK FOOTER //
// src/components/productCard.vue